const STORAGE_KEY = "postLoginRedirect"

// Remember where a logged-out user was heading (path + query) so the login flow can bring them back.
export const rememberPostLoginRedirect = (target) => {
  const value = target || `${window.location.pathname}${window.location.search}`

  if (!value || value === "/" || value.startsWith("/login")) return

  localStorage.setItem(STORAGE_KEY, value)
}

// Returns the remembered in-app target once (and forgets it), or null.
export const consumePostLoginRedirect = () => {
  const value = localStorage.getItem(STORAGE_KEY)

  if (value) localStorage.removeItem(STORAGE_KEY)

  return value && value.startsWith("/") && !value.startsWith("//") ? value : null
}

export const forgetPostLoginRedirect = () => localStorage.removeItem(STORAGE_KEY)
